/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import update from "immutability-helper";
import {vsprintf} from 'sprintf-js';

import BaseContainer from "../../containers/BaseContainer";
import Main from "./Main";
import Navigation from "../../Navigation";
import menu from "../../data/menu";
import {SessionStore} from "../../services/Session";
import {PageActionStore} from "../../services/PageAction";
import {NotificationActions} from "../../services/Notification";

import SelectRole from "../../modals/SelectRole";
import ResetPassword from "../../modals/ResetPassword";
import ForgotPassword from "../../modals/ForgotPassword";
import CONFIG from "../../config";
import {t} from "../../trans";

class MainContainer extends BaseContainer {
    static propTypes = {
        params: PropTypes.shape({
            resource: PropTypes.string
        }),
        location: PropTypes.object.isRequired,
        children: PropTypes.any
    };

    static defaultProps = {};

    constructor(props) {
        super(props, {
            session: SessionStore,
            action: PageActionStore
        });
        this.state.miniNavbar = false;
        this.state.modal = "";
        this.state.menu = this.makeMenu();

        this.onToggleMiniNavbar = this.onToggleMiniNavbar.bind(this);
        this.onLogout = this.onLogout.bind(this);
        this.onClickProfile = this.onClickProfile.bind(this);
        this.onClickSwitchRole = this.onClickSwitchRole.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
    }

    componentDidMount() {
        if (!this.props.params.resource) {
            // Redirect to first menu item:
            let url = this.getFirstMenuItemPath(this.state.menu);
            if (url) Navigation.replace(url);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.props.params.resource) {
            // Redirect to first menu item:
            let url = this.getFirstMenuItemPath(this.state.menu);
            if (url) Navigation.replace(url);
        }
    }

    onToggleMiniNavbar() {
        this.setState({
            miniNavbar: !this.state.miniNavbar
        });
    }

    onLogout() {
        Navigation.gotoLogin();
    }

    onClickProfile() {
        // Navigate to current person's view page
        if (this.hasProfileAccess()) {
            let personId = this.state.session.currentRecord.person.id;
            let personUrl = vsprintf(CONFIG.profileUrl, personId);
            Navigation.push(personUrl);
        }
    }

    hasProfileAccess() {
        let personId = (this.state.session.currentRecord && this.state.session.currentRecord.person ?
            this.state.session.currentRecord.person.id : null);
        if (personId == null) return false;
        let personUrl = vsprintf(CONFIG.profileUrl, "*");
        // if (personUrl.startsWith(CONFIG.mainUrl)) personUrl = personUrl.substring(CONFIG.mainUrl.length);
        // Find if access to person view record is allowed:
        return SessionStore.isAuthorized(personUrl);
    }

    onClickSwitchRole() {
        this.showModal(<SelectRole onClose={this.onCloseModal}/>);
    }

    onClickChangePassword() {

    }

    onClickChangeAutKey() {

    }

    onCloseModal() {
        this.hideModal();
    }

    showModal(ModalComponent) {
        // If some modal is already open then do not open new one.
        if (this.state.modal) return;
        this.setState({
            modal: ModalComponent
        });
    }

    hideModal() {
        this.setState({modal: null});
    }

    render() {
        let session = this.state.session.currentRecord;
        if (!session || !session.person) return null;
        let person = session.person;
        let hasProfileAccess = this.hasProfileAccess();
        let personHasMultipleRoles =
            person.personRoleCollection &&
            person.personRoleCollection.items &&
            person.personRoleCollection.items.length > 1;
        let activeRole = (session ? session.activeRole : null);
        return (
            <Main
                person={person}
                activeRole={activeRole}
                miniNavbar={this.state.miniNavbar}
                leftMenu={this.state.menu}
                onToggleMiniNavbar={this.onToggleMiniNavbar}
                onLogout={this.onLogout}
                onClickProfile={hasProfileAccess ? this.onClickProfile : null}
                onClickSwitchRole={personHasMultipleRoles ? this.onClickSwitchRole : null} >
                {this.state.session && this.state.session.currentRecord && this.state.session.currentRecord.status === "A" ? this.props.children : <div/>}
                {this.state.modal}
            </Main>
        );
    }

    makeMenu() {
        return this.makeMenuItems(menu);
    }

    makeMenuItems(menu) {
        for (let i = 0; i < menu.length; i++) {
            if (menu[i].to) {
                if (!SessionStore.isAuthorized(menu[i].to)) {
                    menu = update(menu, {$splice: [[i, 1]]});
                    i--;
                    continue;
                }
            }
            if (menu[i].content) {
                let newContent = this.makeMenuItems(menu[i].content);
                if (!newContent || newContent.length == 0) {
                    // Remove submenu:
                    if (!menu[i].to) {
                        menu = update(menu, {$splice: [[i, 1]]});
                        i--;
                    } else {
                        menu = update(menu, {[i]:{$unset: ["content"]}});
                    }
                } else {
                    // Modify submenu
                    menu = update(menu, {[i]: {content: {$set: newContent}}});
                }
            }
        }
        return menu;
    }

    getFirstMenuItemPath(menu) {
        for (let m of menu) {
            if (m.to && m.to !== CONFIG.baseUrl && m.to !== CONFIG.mainUrl) return m.to;
            if (m.content) return this.getFirstMenuItemPath(m.content);
        }
        return null;
    }

    /**
     * Execute action
     * @param {PageAction} action
     */
    onAction(action) {
        switch (action.action) {
            case "changeAuthCode":
                this.showModal(<ResetPassword type="authkey" onClose={this.onCloseModal} personId={action.data.id} personEmail={action.data.email}/>);
                break;
            case "changePassword":
                this.showModal(<ResetPassword type="password" onClose={this.onCloseModal} personId={action.data.id} personEmail={action.data.email}/>);
                break;
            case "forgotPassword":
            case "forgotAuthCode":
                let email = this.state.session.currentRecord.person.email;
                if (action.data && action.data.email) email = action.data.email;
                this.showModal(<ForgotPassword email={email} readOnly={true} onClose={this.onCloseModal} resetCode={action.action === "forgotAuthCode"}/>);
                break;
        }
    }

    storeChanged(key, newState, oldState) {
        switch (key) {
            case "action":
                this.onAction(newState.action);
                break;
            case "session":
                /**
                 *
                 * @type {Session}
                 */
                let session = newState.currentRecord;
                if (!session) {
                    // NotificationActions.error.defer(t("Session expired, please login again"));
                    // Login again (and remember last URL before login):
                    Navigation.gotoLogin(this.props.location.basename + this.props.location.pathname);
                    // this.showModal(<AskPassword onClose={this.onCloseModal}/>);
                }
                break;
            default:
                return super.storeChanged(key, newState, oldState);
        }
    }

    loadingFinished(key, newState) {
        switch (key) {
            case "session":
                this.setState({menu: this.makeMenu()});
                break;
        }
    }

    /**
     * Called when specified store fails to load data.
     * By default this method uses notification to display error.
     * @param key Store key
     * @param {BaseRestStoreState} newState Store new state
     * @param {BaseRestStoreState} oldState Store old state
     */
    loadingFailed(key, newState) {
        NotificationActions.actionError.defer(newState.action);
    }

}

export default MainContainer;
